export default {
//  SET_ISLOGIN: (state, val) => {
//    state.isLogin = val
//  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutations.js